import * as TabsPrimitive from '@radix-ui/react-tabs';
import type * as React from 'react';
import { cn } from '#pie/utils/TailwindUtils';

export const TabsTrigger = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>) => (
  <TabsPrimitive.Trigger
    className={cn(
      'p-4 transition-colors duration-200 border-b-2 relative text-content-body border-border-minimal-enabled data-[state=active]:text-action-secondary-enabled data-[state=active]:border-b-action-secondary-enabled data-[state=active]:font-bold data-[state=inactive]:hover:bg-action-secondary-enabled data-[state=inactive]:hover:text-content-reversed data-[state=inactive]:hover:border-b-action-secondary-enabled',
      className,
    )}
    {...props}
  />
);
